import { useState, useEffect } from 'react';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-[72px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20pastel%20product%20collage%20with%20sneakers%20hoodies%20bags%20and%20accessories%20arranged%20artistically%20on%20a%20light%20cream%20background%2C%20minimalist%20aesthetic%20product%20flatlay%20photography%20with%20natural%20lighting%2C%20gentle%20shadows%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20lifestyle%20editorial%20style%20with%20soft%20bokeh%20effect%2C%20european%20minimalist%20catalog%20photography&width=1800&height=1200&seq=hero-bg-kakobuy-01&orientation=landscape"
          alt="Kakobuy products collage background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/40 to-white/85"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-16 pb-20">
        <div className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm rounded-full px-4 py-1.5 mb-8 border border-foreground-200/30">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            <span className="text-[13px] font-medium text-foreground-600 whitespace-nowrap">
              Codziennie aktualizowane
            </span>
          </div>

          <h1 className="font-heading text-5xl md:text-7xl font-bold text-foreground-900 mb-4 leading-[1.1] tracking-tight">
            Kakobuy Spreadsheet
          </h1>
          <p className="font-heading text-3xl md:text-5xl text-foreground-800 mb-8 leading-tight">
            Polska Baza Produktów 2026
          </p>

          <div className="flex items-center justify-center gap-4 mb-12">
            <span className="text-2xl">🛍️</span>
            <span className="text-2xl">🇵🇱</span>
          </div>

          <p className="text-lg md:text-xl text-foreground-600 mb-2 leading-relaxed font-body">
            Największa niezależna baza produktów z Chin.
          </p>
          <p className="text-lg md:text-xl text-foreground-500 mb-12 leading-relaxed font-body">
            Codziennie aktualizowane Kakobuy Finds.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 bg-foreground-900 text-white text-[16px] font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-sm"
            >
              <i className="ri-external-link-line mr-2"></i>
              Kakobuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 border-2 border-foreground-800 text-foreground-800 text-[16px] font-semibold rounded-full hover:bg-foreground-800 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              Buy It Now
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 inline-block transition-transform"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-14">
            {[
              { icon: 'ri-checkbox-circle-line', text: 'Aktualizacje codziennie' },
              { icon: 'ri-book-open-line', text: 'Darmowe przewodniki' },
              { icon: 'ri-apps-line', text: 'Ponad 14 kategorii' },
              { icon: 'ri-shield-check-line', text: 'Niezależne informacje' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-[14px] text-foreground-500 whitespace-nowrap">
                <i className={`${item.icon} text-primary-500 text-base`}></i>
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}